<div class="row modal-bar">
  <div class="col-sm-6">
    <h5 class="modal-title">{{ 'DIALOGS.RENEWAL_MAPPING.TITLE' | translate }}</h5>
  </div>
  <div class="col-sm-6">
    <div class="modal-actions">
      <div class="modal-close">
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="cancel()"></button>
      </div>
    </div>
  </div>
</div>

@if (form) {
  <form [formGroup]="form" class="form-content">
    <div class="section-wrapper">
      <div class="form-layout">
        <div class="row">
          <div class="col-lg-12">
            <p>{{ 'DIALOGS.RENEWAL_MAPPING.INTRO' | translate }}</p>
          </div>
        </div>
        @if (!hasTargets) {
          <div class="row">
            <div class="col-lg-12">
              <div class="important-info info-highlight mb-3">
                <p class="info-label info-sub">{{ 'DIALOGS.RENEWAL_MAPPING.NO_TARGETS_AVAILABLE' | translate }}</p>
              </div>
            </div>
          </div>
        }
        @if (plan.SourcePassePartouts.length > 0) {
          <div class="renewal-mapping-grid mt-3">
            <div class="row mb-2">
              <div class="col-md-6"><strong>{{ 'DIALOGS.RENEWAL_MAPPING.COL.SOURCE' | translate }}</strong></div>
              <div class="col-md-6"><strong>{{ 'DIALOGS.RENEWAL_MAPPING.COL.TARGET' | translate }}</strong></div>
            </div>
            @for (source of plan.SourcePassePartouts; track trackBySourceId($index, source)) {
              <div class="row align-items-center mb-3"
                >
                <div class="col-md-6 source-name">
                  <div><strong>{{ source.Name }}</strong></div>
                  <div class="text-muted">{{ source.SeasonName }}</div>
                </div>
                <div class="col-md-6">
                  <ng-select
                    [items]="plan.EligibleTargets"
                    bindLabel="Name"
                    bindValue="Id"
                    [formControlName]="controlKey(source.Id)"
                    [clearable]="true"
                    placeholder="{{ 'DIALOGS.RENEWAL_MAPPING.SKIP_PLACEHOLDER' | translate }}"
                    notFoundText="{{ 'GENERIC.EDITDIALOG.PLACEHOLDER.NOITEMSFOUND' | translate }}"
                    appendTo="body">
                    <ng-template ng-label-tmp let-item="item">
                      {{ item.Name }}
                    </ng-template>
                    <ng-template ng-option-tmp let-item="item">
                      <div>{{ item.Name }}</div>
                      <small class="text-muted">{{ item.SeasonName }}</small>
                    </ng-template>
                  </ng-select>
                </div>
              </div>
            }
          </div>
        }
        <div class="form-layout-footer row mt-4">
          <div class="col-md-6">
            <button type="button" (click)="confirm()" class="btn btn-block btn-primary bd-0" [disabled]="!hasTargets">
              <i class="far fa-save"></i><span>{{ 'BTN.CONTINUE' | translate }}</span>
            </button>
          </div>
          <div class="col-md-6">
            <button type="button" (click)="cancel()" class="btn btn-block btn-secondary bd-0">
              <i class="fas fa-ban"></i><span>{{ 'BTN.CANCEL' | translate }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </form>
}
